export const appConstants = {
  APP_INITIALIZED: 'APP_INITIALIZED'
}
